/*global module */
module.exports = {
	dashed: '8, 8',
	solid: ''
};
